// src/components/Sidebar.js
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Sidebar.css';

const Sidebar = ({ isOpen, closeSidebar }) => {
  const location = useLocation();

  const menuItems = [
    { path: '/dashboard', label: 'Overview', icon: '📊' },
    { path: '/dashboard/vendors', label: 'All Stores', icon: '🏪' }, 
    // 🔥 NAYA: Categories wala link add kar diya 🔥
    { path: '/dashboard/categories', label: 'Categories', icon: '📂' }, 
    { path: '/dashboard/products', label: 'All Products', icon: '🛍️' }, 
    { path: '/dashboard/orders', label: 'Live Orders', icon: '📦' },
    { path: '/dashboard/users', label: 'Customers', icon: '👥' },
    { path: '/dashboard/tickets', label: 'Support Tickets', icon: '🎫' },
    { path: '/dashboard/settings', label: 'Settings', icon: '⚙️' },
  ];

  return (
    <>
      <div 
        className={`mobile-overlay ${isOpen ? 'show' : ''}`} 
        onClick={closeSidebar}
      ></div>

      <aside className={`sidebar-container ${isOpen ? 'open' : ''}`}>
        <nav className="sidebar-nav">
          <div className="nav-section-title">Main Menu</div>
          
          {menuItems.map((item) => {
            // 🔥 THE FIX: 'Overview' tab ko strictly check karo taaki multiple tabs highlight na hon 🔥
            const isActive = item.path === '/dashboard' 
              ? location.pathname === '/dashboard' || location.pathname === '/dashboard/'
              : location.pathname.startsWith(item.path);

            return (
              <Link 
                key={item.path}
                to={item.path} 
                className={`nav-link ${isActive ? 'active' : ''}`} 
                onClick={closeSidebar}
              >
                <span className="nav-icon">{item.icon}</span>
                <span className="nav-text">{item.label}</span>
              </Link>
            );
          })}
        </nav>
      </aside>
    </>
  );
};

export default Sidebar;